import { useProtectedRoute } from '@context/ProtectedRouteContext';
import { memo } from 'react';
import { IDashboardLayoutProps } from './DashboardLayout.types';
import styles from './styles.module.scss';

export const DashboardLayout = memo<IDashboardLayoutProps>(({ children }) => {
  const { isProtected } = useProtectedRoute();
  // eslint-disable-next-line react/jsx-no-useless-fragment
  if (!isProtected) return <>{children}</>;

  return <div className={styles.container}>{children}</div>;
});

DashboardLayout.displayName = 'DashboardLayout';

export default DashboardLayout;
